import { MiCardList, MiMenu } from "@miplatform/components";
import { BUTTON_LABELS } from "@miplatform/constants";
import { IBidLineItemResponse } from "@miplatform/types";
import { mdiPencilOutline, mdiTrashCanOutline } from "@mdi/js";
import { Box, useTheme } from "@mui/material";
import { SectionInfo } from "../../../components/SectionInfo/SectionInfo";

export const BidLineItemCard = ({
  item,
  disabled,
  handleEdit,
  handleDelete,
}: {
  item: IBidLineItemResponse;
  disabled: boolean;
  handleEdit: (item: IBidLineItemResponse) => void;
  handleDelete: (item: IBidLineItemResponse) => void;
}) => {
  const theme = useTheme();

  const sections = [
    {
      fieldset: [
        {
          renderValue: (data: IBidLineItemResponse) => (
            <SectionInfo data={data} />
          ),
        },
        {
          label: "Categories",
          field: "categories",
          renderValue: (data: IBidLineItemResponse) =>
            data.categories.map((c) => c.name).join(", ") || "--",
          style: { maxWidth: 500 },
        },
        {
          label: "Footnote",
          field: "footnote",
          renderValue: (data: IBidLineItemResponse) => data.footnote || "--",
          style: { maxWidth: 750 },
        },
      ],
    },
  ];
  const renderItemActions = (item: IBidLineItemResponse) => {
    const actions = [
      {
        label: BUTTON_LABELS.EDIT,
        icon: mdiPencilOutline,
        action: () => handleEdit(item),
        disabled,
      },
      {
        label: BUTTON_LABELS.DELETE,
        icon: mdiTrashCanOutline,
        action: () => handleDelete(item),
        color: theme.palette.red.main,
        disabled,
      },
    ];

    return actions.length > 0 ? (
      <Box onClick={(e) => e.stopPropagation()}>
        <MiMenu data={actions} />
      </Box>
    ) : null;
  };
  return (
    <MiCardList
      key={item.id}
      item={item}
      sections={sections}
      containerStyles={{}}
      renderItemActions={() => renderItemActions(item)}
    />
  );
};
